"use client";

import useInterval from "@hudson/ui/lib/use_interval";
import Session from "@lib/session";
import router from "next/router";

export default function CheckForSessionExpiration() {
  // Check expirations every 20 seconds.
  useInterval(() => {
    if (Session.isExpired(1)) {
      Session.clearSession();
      if (router.pathname.includes("/book"))
        router.replace(`/${router.query.siteId}/book?session_expired=1`);
    }
  }, 20000);

  return null;
}
